<script setup lang="ts">
import { computed, ref } from 'vue';
import Heading from '../General/Heading.vue';
import Modal from '../General/Modal.vue';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import Button from '../General/Button.vue';
import LoadingIcon from '../General/LoadingIcon.vue';
import { useClassStore, useSignalRStore, useUserStore } from '../../stores';

const signalr = useSignalRStore()
const classStore = useClassStore()
const user = useUserStore()

const modalShow = ref<boolean>(true)
const isRequestSent = computed<boolean>(() => {
    return classStore.requestedStudentIds.includes(user.userInfo?.id || 0)
})

function handleSendRequest() {
    signalr.studentAskJoinRoom()
}

const { t } = useI18n()
</script>

<template>
    <Modal v-model="modalShow" :static="true">
        <Heading alignment="center">{{ t(TEXT.request_to_join) }}</Heading>
        <div class="text-center my-7"
            v-html="t(!isRequestSent ? TEXT.request_to_join_not_sent : TEXT.request_to_join_sent)">
        </div>
        <Button v-if="!isRequestSent" color="warning" class="mx-auto" @click="handleSendRequest">
            {{ t(TEXT.send_request) }}
        </Button>
        <LoadingIcon v-else class="mx-auto" />
    </Modal>
</template>